import { LockIcon } from 'lib-core'


export default LockIcon
